import { render, staticRenderFns } from "./recordValuation.vue?vue&type=template&id=5a4d58be&scoped=true&"
import script from "./recordValuation.vue?vue&type=script&lang=js&"
export * from "./recordValuation.vue?vue&type=script&lang=js&"
import style0 from "./recordValuation.vue?vue&type=style&index=0&id=5a4d58be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d58be",
  null
  
)

export default component.exports